module.exports = __webpack_public_path__ + "static/media/Basic-Host-Reseller.174e1bae.png";